import React, { useContext, useState } from "react";
import { Scrollbars } from 'react-custom-scrollbars';
import styled, { css } from "styled-components";
import { Checkbox } from "xsolla-uikit";
import { ProductContext } from '../context';
import { sections, themes } from '../defaults';
import { SbCatSelect, SbSelect } from './SbSelect';
import { SbThemeSelector } from './SbThemeSelector';
import Sb0top from "./Sb0top";
import StoreSbColor from "./StoreSbColor";
import StoreSbSize from "./StoreSbSize";
import { SbSection } from './SbSection';
import { PSsections } from './PSsections';
import { CSSpsFormGroup, HR } from '../components/uikit-b2c/uikit-b2c';







export const SBgeneral = ({}) => {

  const valueFromContext = useContext(ProductContext);

  const theme = React.useContext(ProductContext).getTheme();

  const [state, setstate] = useState({
    changeColor: 'colorAccent',
  })


  return (
    <SbSection
      title ='General Settings'
    >





      <SbThemeSelector target='global' />




      <SbCollapsible opened={false}>
        <div style={{display: 'block',
          background: 'rgba(207, 219, 233, 0.25)',
          borderRadius: 4,
        }}>

          <div className="xx_set_head">
            <div className="xx_img_menu_left">
              <div className="xsb_sett_head">
                Style configuration
              </div>
            </div>
              {/* <div className="xx_img_menu_right"><div className="xx_img_menu_li"><div className="xx_but_menu_icon xx_but_menu_icon--secondary"><div>delete</div></div></div></div> */}
          </div>




          <div className="xsb_set_line xsb_set_line--fullsub">

            <div className="xx_set_line">
              <StoreSbColor changeOneAtt={'colorBg'} type='random' />
            </div>

            <br/>

            <div className="xx_set_line">
              <Checkbox
                  name="bgGlobal"
                  label="Picture Background"
                  input={{
                    value: theme['backgroundUrl'],
                    onChange: (e)=>{
                      valueFromContext['changeTheme']('global', {
                        ...theme,
                        backgroundUrl: false,
                      })
                    },
                  }}
                />
            </div>



<br/>







            <div className="xx_set_line">

              <CssColorSwitcher>
                <CssColorSwitch
                  active = {state['changeColor'] === 'colorText' ? true : false }
                  onClick={()=>{setstate({changeColor: 'colorText'})}}
                >Text</CssColorSwitch>

                <CssColorSwitch
                  active = {state['changeColor'] === 'colorAccent' ? true : false }
                  onClick={()=>{setstate({changeColor: 'colorAccent'})}}
                >Accent</CssColorSwitch>

                <CssColorSwitch
                  active = {state['changeColor'] === 'colorBg' ? true : false }
                  onClick={()=>{setstate({changeColor: 'colorBg'})}}
                >Bg</CssColorSwitch>
              </CssColorSwitcher>

              <StoreSbColor changeOneAtt={state['changeColor']} type='picker' />

              <br/>

            </div>



            <div className="xx_set_line">

              <div className="xx_set_line">
                Global Font
              </div>
              <SbSelect
                active={valueFromContext['theme']['fontFamily']}
                menuHandler={(val) => {
                  valueFromContext['changeTheme']('global', {
                    ...theme,
                    fontFamily: val,
                  })
                }}
                options={[
                  {
                    title: 'Take 2 font (Montserrat)',
                    value: '"Montserrat", "Roboto", "Helvetica Neue", "Arial"',
                  },
                  {
                    title: 'Xsolla Font (Graphic)',
                    value: '"Graphiklcg", "Roboto", "Helvetica Neue", "Arial"',
                  },
                  {
                    title: 'Roboto',
                    value: '"Roboto", "Graphiklcg", "Roboto", "Helvetica Neue", "Arial"',
                  },
                  {
                    title: 'Droid Sans',
                    value: '"Droid Sans", "Graphiklcg", "Roboto", "Helvetica Neue", "Arial"',
                  },
                  {
                    title: 'Monospace',
                    value: '"Space Mono", "Graphiklcg", "Roboto", "Helvetica Neue", "Arial"',
                  },
              ]}
              />

              </div>





            <div className="xx_set_line">
              <p>Pay Station width:  {theme['psWidth']}px</p>
              <StoreSbColor changeOneAtt={'psWidth'}/>
            </div>



            <div className="xx_set_line">
              <p>Border radius:  {theme['borderRadius']}px</p>
              <StoreSbColor changeOneAtt={'borderRadius'}/>
            </div>


            <div className="xx_set_line">
              <p>Paddings: {theme['paddings']}px</p>
              <StoreSbColor changeOneAtt={'paddings'} />
            </div>



            <div className="xx_set_line">
              <p>Geometry Contrast: {theme['cardContrast']}</p>
              <StoreSbColor changeOneAtt={'cardContrast'} />
            </div>



{/*
            <div className="xx_set_sect">
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorText'} type='hue' />
              </div>
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorText'} type='range' />
              </div>
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorText'} type='input' />
              </div>

            </div>

            <div className="xx_set_sect">
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorAccent'} type='hue' />
              </div>
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorAccent'} type='input' />
              </div>
            </div>

            <div className="xx_set_sect">
              <div className="xx_set_line">
                <StoreSbColor changeOneAtt={'colorBg'} type='hue' />
              </div>
              <div className="xx_set_line">
              <StoreSbColor changeOneAtt={'colorBg'} type='input' />
              </div>
            </div> */}



          </div>

          </div>

        </SbCollapsible>



      </SbSection>


)
}




export default function SiteBuilder({type}) {

  const valueFromContext = useContext(ProductContext);

  const theme = React.useContext(ProductContext).getTheme();





  const menuHandler1 = (val) => {
    menuHandler(0, 'activeModule', val);
  }
  const menuHandler2 = (val) => {
    menuHandler(0, 'activeGroup', val);
  }


  const menuHandler = (blockOrder = 0, module = 'activeModule', newActive) => {
    let newSections = [...valueFromContext['sections']];
    debugger
    if (typeof newActive === 'object') {

      newSections[blockOrder][module] = newActive[0];
      newSections[blockOrder]['activeSubGroup'] = newActive[1];
    } else {
      newSections[blockOrder][module] = newActive;
    }
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }

  const getActive = (val)=> {
    let ret;
    themes.forEach((oneTheme, ind) => {
      return ret = oneTheme['id'] === val.getTheme('id') ? ind : ret;
    })
    return ret;
  }





  const deleteSection = (deleteSection) => {
    let newSections = [...valueFromContext['sections']];
    if (newSections.length > 1) {newSections.splice(deleteSection, 1)}
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }


  const createSection = () => {
    let newSections = [...valueFromContext['sections']];
    let newSection = {...valueFromContext['sections'][valueFromContext['sections'].length - 1]}
    // newSection['menu'] = true;
    newSection['title'] = true;
    newSection['cardWidth'] = 200;
    newSection['limit'] = 0;
    newSections.push(
      newSection
    )

    valueFromContext.setStateFrom(
      'sections', newSections
    )
  }




  const [shown, setShown] = React.useState(false)


  return (
    <CssSb00>
      {/* <CssSbSection>
        <CssSbSectionH>
          Store
        </CssSbSectionH>
      </CssSbSection> */}

      <Sb0top type={type} />

      <div
        className="x_left0"
        style={{
          height: "100%",
          padding: "0",
          background: "#495c6b",
          // overflowY: 'auto',
          // padding: '0px 16px 0 16px',
          // background: '#c5d0db',
        }}
      >
        <Scrollbars
          style={{
            height: "100%",
          }}
        >
          <div style={{ padding: "16px 16px 0 16px" }}>
            <SBgeneral />

            {type === "paystation" && (
              <PSsections
                ps={valueFromContext["ps"]}
                handleSave={(newPs) => {
                  valueFromContext.setStateFrom("ps", newPs);
                }}
              />
            )}

            {type === "store" && (
              <SbSection title="Store Pages">
                {valueFromContext && (
                  <SbSelect
                    placeholder="Select shop preset"
                    menuHandler={(val) => {
                      valueFromContext.setStateFrom(
                        "sections",
                        sections[val]
                      );
                    }}
                    // help={<p><i>Pre-defined store configurations</i></p>}
                    options={[
                      {
                        title: "Default",
                        value: 0,
                      },
                      {
                        title: "Simple",
                        value: 1,
                      },
                      {
                        title: "Large catalog",
                        value: 2,
                      },
                      {
                        title: "VC and Subscriptions",
                        value: 3,
                      },

                      {
                        title: "🇧🇪 SLIDERS!",
                        value: 4,
                      },
                    ]}
                  />
                )}
              </SbSection>
            )}

            {type === "store" &&
              valueFromContext["sections"].map((section, ind) => (
                <SbSection
                  key={`store_${ind}`}
                  title={`Store section ${ind + 1}`}
                  moveable={true}
                  deleteable={
                    valueFromContext["sections"].length > 1 ? true : false
                  }
                  blockOrder={ind}
                  deleteSection={(ind) => {
                    deleteSection(ind);
                  }}
                >
                  {valueFromContext["virtualItems"] && (
                    // && valueFromContext['sections'][ind]['activeModule'] === 'virtualItems'
                    <div>
                      {/* <div class="xsb_sett_label">Group:</div> */}
                      <SbCatSelect
                        menuHandler={(val) => {
                          menuHandler(ind, "activeGroup", val);
                        }}
                        options={[
                          {
                            // title: 'Virtual items',
                            module: "virtualItems",
                            items: [...valueFromContext["virtualItems"]],
                            menuHandler: (val) => {
                              menuHandler(
                                ind,
                                "activeModule",
                                "virtualItems"
                              );
                              menuHandler(ind, "activeGroup", val);
                            },
                          },
                          {
                            title: "Virtual currency",
                            module: "currency",
                            menuHandler: () => {
                              menuHandler(ind, "activeModule", "currency");
                            },
                          },
                          {
                            title: "Subscriptions",
                            module: "subscriptions",
                            menuHandler: () => {
                              menuHandler(
                                ind,
                                "activeModule",
                                "subscriptions"
                              );
                            },
                          },
                        ]}
                        activeModule={
                          valueFromContext["sections"][ind]["activeModule"]
                        }
                        activeGroup={
                          valueFromContext["sections"][ind]["activeGroup"]
                        }
                        activeSubGroup={
                          valueFromContext["sections"][ind]["activeSubGroup"]
                        }
                      />
                    </div>
                  )}

                  {/* SLIDER */}
                  <div className="xx_set_line">
                    <Checkbox
                      name="slider"
                      label="Show as slider"
                      input={{
                        value: valueFromContext["sections"][ind]["slider"],
                        onChange: (e) => {
                          menuHandler(
                            ind,
                            "slider",
                            !valueFromContext["sections"][ind]["slider"]
                          );
                        },
                      }}
                    />
                  </div>

                  {/* LIMIT */}
                  <div className="xsb_sett_form_li">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        name="limit"
                        label="Limit quantity: "
                        input={{
                          value:
                            valueFromContext["sections"][ind]["limit"] || "",
                          onChange: (e) => {
                            let newLimit = valueFromContext["sections"][ind][
                              "limit"
                            ]
                              ? null
                              : 4;
                            menuHandler(ind, "limit", newLimit);
                          },
                        }}
                      />
                      <div
                        className="xsb_sett_q0"
                        style={{ margin: "0 0 .5rem 1rem" }}
                      >
                        {valueFromContext["sections"][ind]["limit"] > 1 && (
                          <div
                            className="xsb_sett_q_control"
                            onClick={() =>
                              menuHandler(
                                ind,
                                "limit",
                                --valueFromContext["sections"][ind]["limit"]
                              )
                            }
                          >
                            &minus;
                          </div>
                        )}

                        {valueFromContext["sections"][ind]["limit"] <= 1 && (
                          <div
                            className={`xsb_sett_q_control ${
                              valueFromContext["sections"][ind]["limit"] === 0
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => menuHandler(ind, "limit", 0)}
                          >
                            ×
                          </div>
                        )}

                        <div className="xsb_sett_q_num">
                          {!!valueFromContext["sections"][ind]["limit"] &&
                            valueFromContext["sections"][ind]["limit"]}
                          {!valueFromContext["sections"][ind]["limit"] && (
                            <span>∞</span>
                          )}
                        </div>
                        <div
                          className="xsb_sett_q_control"
                          onClick={(e) => {
                            e.preventDefault();
                            menuHandler(
                              ind,
                              "limit",
                              ++valueFromContext["sections"][ind]["limit"]
                            );
                          }}
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="xx_set_line" style={{ display: "flex" }}>
                    Size: <StoreSbSize blockOrder={ind} />
                  </div>

                  <div
                    className="xx_set_line"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                    }}
                  >
                    <Checkbox
                      name="menu"
                      label="Menu"
                      input={{
                        value: valueFromContext["sections"][ind]["menu"],
                        onChange: (e) =>
                          menuHandler(
                            ind,
                            "menu",
                            !valueFromContext["sections"][ind]["menu"]
                          ),
                      }}
                    />

                    <Checkbox
                      name="title"
                      label="Title"
                      input={{
                        value: valueFromContext["sections"][ind]["title"],
                        onChange: (e) =>
                          menuHandler(
                            ind,
                            "title",
                            !valueFromContext["sections"][ind]["title"]
                          ),
                      }}
                    />

                    <Checkbox
                      name="back"
                      label="Effect"
                      input={{
                        value: valueFromContext["sections"][ind]["template"],
                        onChange: (e) => {
                          let val =
                            valueFromContext["sections"][ind]["template"];
                          menuHandler(
                            ind,
                            "template",
                            !!val ? false : "blurred"
                          );
                        },
                      }}
                    />
                  </div>

                  <div style={{ display: "flex" }}>
                    <Checkbox
                      name="back"
                      label={
                        valueFromContext.sections[ind].theme
                          ? " "
                          : "Section custom theme"
                      }
                      input={{
                        value: valueFromContext.sections[ind].theme || "",
                        onChange: (e) => {
                          let on = valueFromContext.sections[ind].theme
                            ? true
                            : false;

                          if (on) {
                            valueFromContext.changeTheme(ind, null);
                          } else {
                            valueFromContext.changeTheme(ind, themes[0]);
                          }
                        },
                      }}
                    />

                    {valueFromContext.sections[ind].theme && (
                      <div
                        className="xx_set_line"
                        style={
                          {
                            // display: 'grid',
                            // gridTemplateColumns: `${valueFromContext.sections[ind].theme ? 'minmax(100px, 100%) minmax(0px, 44px)' : '1fr'}`,
                            // gridColumnGap: 8,
                          }
                        }
                      >
                        <SbThemeSelector target={ind} />

                        {/* <CssThemeReset className="xsb_but_link_input"
            onClick={()=>{valueFromContext.changeTheme(ind, null)}}
          >
            <div className="xx_but_menu_icon xx_but_sett_icon--blue">backspace</div>
          </CssThemeReset> */}
                      </div>
                    )}
                  </div>
                </SbSection>
              ))}

            {type === "store" && (
              <div className="xsb_set_line">
                <div
                  className="xsb_but_newapi"
                  onClick={() => {
                    createSection();
                  }}
                >
                  <div className="xsb_1_icon_sm w-embed">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.02214 3.99978H6.03689L6 6.02886L19.2389 6.0293V6.8967H18.7316V7.91146H18.2242V8.92622H17.7168V9.94097H17.2094V10.9557H16.702V11.9705H16.1947V12.9852H15.6873V14L6 13.9996L6.03689 15.9998H14.0293V17.0145H6.03689H5.02214V14.1474V6.0293V5.01454L3 5.00109V3.98633L5.02214 3.99978ZM6 18.0002H7.97786V20.0297H6V18.0002ZM11.9998 18.0002H14.0293V20.0297H11.9998V18.0002Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div className="xsb_but_newapi_label">
                    <div className="text-block-19">Add Store Section</div>
                  </div>
                </div>
              </div>
            )}

            <br />

            {/* <div className="xsb_set_line"> */}
              <div className="xx_set_sect_info0">
                {/* <p>
                  Set up your items in{" "}
                  <a
                    href={`https://publisher.xsolla.com/${15924}/projects/${
                      window.xProjectId
                    }/storefront/virtual-items/`}
                    className="xsb_link_white xsb_link_white--hint"
                    target="_blank"
                  >
                    Store CMS
                  </a>
                </p> */}

                <p>Press ESC to hide the editor</p>
              </div>
            {/* </div> */}
          </div>
        </Scrollbars>
      </div>
    </CssSb00>
  );
}


const CssSb00 = styled.div`

  background: #4f6374;
  color: #919fa9;

  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0;
  height: 100%;
  padding: 64px 24px 0 24px;
  display: flex;
  width: 320px;
  flex-direction: column;
  /* width: 100%; */
  align-items: center;
  justify-content: center;
  /* align-content: stretch; */
  /* height: 100vh; */

  & div {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }


  /*FIXES FOR UIKIT*/

  /* & .xsui-checkbox--primary:not(.xsui-checkbox--disabled):not(.xsui-checkbox--error) .xsui-checkbox__input:checked+.xsui-checkbox__label:after {
    background-color: rgba(255,255,255,0.2);
    border-color: rgba(255,255,255,0.3);
  }
  & .xsui-checkbox--primary:not(.xsui-checkbox--disabled):not(.xsui-checkbox--error) .xsui-checkbox__input+.xsui-checkbox__label:after {
    background-color: rgba(255,255,255,0.0);
    border-color: rgba(255,255,255,0.1);
    color: #0073f7;
  } */

`;


const CssColorSwitcher = styled.div`
  width: 100%;
  display: grid;
  /* grid-template-columns: auto; */
  grid-auto-flow: column dense;
  grid-column-gap: 6px;
  margin-bottom: 4px;
`;


const CssColorSwitch = styled.div`
  flex-grow: 1;
  cursor: pointer;
  /* background-color: #506373; */
  display: flex;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid rgba(145, 159, 169, 0.17);
  color: #ccdbea;
  ${props => props.active && css`
    background: white;
    color: #506373;
  `}
  &:hover {
    border: 1px solid #ddd;
  }
`;


const CssSbSection = styled.div`
  /* background-color: #506373; */
  display: flex;
  width: 100%;
  align-items: center;
  margin: 16px;
  padding: 16px;
  border: 1px solid #ddd;
`;
const CssSbSectionH = styled.div`
  /* background-color: #506373; */
  display: flex;
  align-items: center;
`;





const SbLine = ({
  children,
}) => {
  return (
    <div className="xsb_set_line xsb_set_line--fullsub">{children}</div>
  )
}















export const CssLoginPop0 = styled.div`

  @media (max-width: 991px) {

  }

  @media (max-width: 767px) {

  }

  @media (max-width: 479px) {

  }
`



export const CssSelectB = styled.div`
  transition: all 150ms ease-in-out;
  transform: translateY(-8px);
  padding: 0;
  opacity: 0;
  ${({shown}) => shown && css`{
    transform: translateY(0px);
    opacity: 1;
    z-index: 1;
  }`};
`

export const CssSelect = styled.div`
  overflow: ${({shown}) => shown ? 'visible' : 'hidden'};
`
export const CssMenuLi = styled.div`
  background-color: ${({active}) => active ? '#157afb' : 'transparent'};
  color: ${({active}) => active ? 'white' : 'inherit'};
`




export function SbCollapsible({
  opened = true,
  children
}) {
  let [open, setOpen] = useState(opened);
  return (
    <div className="xx_set_line" style={{display: 'block'}}>

      <CssCollapsible
        open={open}
        className="xx_set_sect"
        onClick={()=>{!open && setOpen(true)}}
        >

          {open && <CssIcon className="xx_but_menu_icon xx_but_sett_icon--blue"
            style={{right:0}}
            onClick={()=>{setOpen(!open)}}
          ><div>expand_less</div></CssIcon>}

          {!open && <CssIcon className="xx_but_menu_icon xx_but_sett_icon--blue"
            style={{right:0}}
          ><div>expand_more</div></CssIcon>}

          {children}
      </CssCollapsible>

    </div>
)}




export const CssIcon = styled.div`
  position: absolute;
  right: 24px;
  height: 52px;
  cursor: pointer;
  z-index: 0;
`


export const CssThemeReset = styled.div`
  /* position: absolute; */
  /* right: 24px; */
  height: 44px;
  width: 44px;
  cursor: pointer;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`




export const CssCollapsible = styled.div`
  position: relative;
  max-height: 54px;
  overflow: hidden;
  transition: all 150ms ease-in-out;

  ${({open}) => open && css`{
    max-height: none;
    overflow: auto;
  }`};
`


